import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	transform: rotate(180deg);
	margin-left: auto;
`;

export const CountWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 20px;
	min-width: 20px;
`;

export const Circle = styled.div`
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 20px;
	color: ${colors.grey8};
	padding-left: 6px;
	cursor: default;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	span {
		font-weight: 500;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	padding: 8px;
	align-items: center;

	&:hover {
		background-color: ${colors.green0};
	}
`;
